import React from 'react';
import { FolderKanban, Gauge, History, Users, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { buildRoleWorkspaceNavItems } from '../config/roleWorkspaceConfig';
import RoleLayoutShell from './RoleLayoutShell';

const ProjectManagerLayout = () => {
  const auth = useAuth();
  const navItems = buildRoleWorkspaceNavItems('project_manager', auth).map((item) => ({
    ...item,
    Icon: item.to === '/profile' ? User : item.to === '/project-manager' ? Gauge : item.to.includes('projects') ? FolderKanban : item.to.includes('history') ? History : Users,
    anyPermissions: item.permission,
  }));

  return <RoleLayoutShell title="EMS" subtitle="Project Manager Workspace" navItems={navItems} />;
};

export default ProjectManagerLayout;
